import script from "./ConfirmManual.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmManual.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmManual.vue?vue&type=style&index=0&id=8bd31e56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bd31e56"]])

export default __exports__